
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { noop, Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { IpService } from 'projects/shop/src/app/+shared/services/user-ip.service';

@Injectable()
export class DevAccessInterceptor implements HttpInterceptor {

  constructor(
    private _ipService: IpService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = request.clone({
      headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
    })

    let reqWithIp;
    this._ipService.ip$.pipe(
      tap(
        res => {
          reqWithIp = request.clone({
            headers: request.headers.set('x-forwarded-for', res)
          })

        }
      )
    ).subscribe(noop)

    return next.handle(request.url.includes('-dev.') ? req! : reqWithIp!)
  }
}